import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

export const Content = styled(Typography)(props => `
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-left: 5px;
  color: ${props.type === 'error' ? 'red' : 'green'};
  text-align: ${props.align === 'right' ? 'right' : 'left'} !important;
`)
